import { isBrowser } from 'ha/helpers/isBrowser';
import { reportError } from 'ha/helpers/bugsnag/reportError';

import { isBannerClosed } from './isBannerClosed';
import { isPageWithOverlay } from './isPageWithOverlay';

export const preventBodyScrolling = () => {
  // fix issue for background scrolling with the opened banner
  if (isPageWithOverlay(window.location.pathname)) {
    document.body.style.overflow = 'hidden';
  }
};

export const allowBodyScrolling = () => {
  document.body.style.overflow = 'unset';
};

/**
 * The function adds window.OptanonWrapper
 * In the case of the OneTrust CDN, the OptanonWrapper function is called after banner script execution.
 * You can use the OptanonWrapper function to listen for a user event and determine script behavior based on the user event.
 */
export const initOptanonWrapper = (callback: () => void) => {
  if (!isBrowser()) {
    return undefined;
  }

  if (!callback) {
    reportError("Callback in OptanonWrapper doesn't exist");
    return undefined;
  }

  if (!isBannerClosed()) {
    // first loading
    preventBodyScrolling();

    window.OptanonWrapper = () => {
      // eslint-disable-next-line new-cap
      if (window.OneTrust?.IsAlertBoxClosed()) {
        callback();
        allowBodyScrolling();
      }
    };
  } else {
    // callback have to be called inside OptanonWrapper.
    // it prevents situations where Rudderstack loads all destinations
    // because Onetrust is not yet initialized and
    // window.OnetrustActiveGroups cannot be found.
    window.OptanonWrapper = () => {
      callback();
    };
  }
  return undefined;
};
